import React from 'react';
import { Helmet } from 'react-helmet';

import Faq from '../../Components/Faq/Faq';

// Restored & Refined Components
import HeroSection from '../../Components/Home/HeroSection';
import StudyGoalSection from '../../Components/Home/StudyGoalSection';
import FeaturesSection from '../../Components/Home/FeaturesSection';
import TopCollegesSection from '../../Components/Home/TopCollegesSection';
import UniversityGridSection from '../../Components/Home/UniversityGridSection';
import TopProgramsSection from '../../Components/Home/TopProgramsSection';
import ProgramSection from '../../Components/Home/ProgramSection';
import TopPlacesSection from '../../Components/Home/TopPlacesSection';
import TopCoursesSection from '../../Components/Home/TopCoursesSection';
import ExamSection from '../../Components/Home/ExamSection';

const Home = () => {
  return (
    <div className="bg-white">
      <Helmet>
        <title>GetFast Education | Top Best Education Consultancy in India</title>
        <meta name="description" content="GetFast Education - India's top education consultancy. Get expert guidance for admissions in online colleges, regular colleges, distance education. Best consultancy for all education services." />
        <meta name="keywords" content="top best consultancy India, best education consultancy, admissions consultancy, online college admissions, regular college admissions, distance education India, GetFast Education, exam preparation, career counseling, university admissions India" />
        <link rel="canonical" href="https://getfasteducation.com/" />
      </Helmet>
      {/* Main Content Sections */}
      <HeroSection />

      <StudyGoalSection />

      <FeaturesSection />

      <TopCollegesSection />

      <UniversityGridSection />

      <TopProgramsSection />

      <ProgramSection />

      <TopPlacesSection />

      <TopCoursesSection />

      <ExamSection />

      {/* FAQ */}
      <Faq />
    </div>
  );
}

export default Home;
